import React from "react";
import {BackButton} from "../../components/BackButton";
import {TopNav} from "../../components/TopNav";

export function ErrorPage() {
    return (<TopNav leftElement={<BackButton/>} label="Erro"/>);
}